document.addEventListener("DOMContentLoaded", () => {
  const items = document.querySelectorAll(".timeline-item");

  console.log('animation');

  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.querySelectorAll('.timeline-item-child').forEach((element,index) => {
          setTimeout(()=> {
            element.classList.add("in-view");
          }, 200 + index * 600);
        })
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.3 });

  items.forEach(item => observer.observe(item));
});
